/**
 * If a professional must, can or does not need to track attendance.
 */
export enum AttendanceTrackerAssignmentType {
  Mandatory = 'mandatory',
  Optional = 'optional',
  NotApplicable = 'not-applicable',
}
